export default __webpack_public_path__ + "static/media/form-bg.9ffb1725.svg";